<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <!-- <v-img
          :src="`https://www.googleapis.com/download/storage/v1/b/makeup-images1/o/a4.png?generation=1555955554330676&alt=media`"
          class="my-3"
          contain
          height="300"
        ></v-img>-->
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">Det här ska ju bli coolt</h1>
        <p class="subheading font-weight-regular">Det här är någon jävla brödtext eller så...</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
	data: () => ({})
}
</script>

<style>
</style>
